import React from "react";

const Crowd = () => (
  <section className="crowd" aria-labelledby="crowd-title">
    <div className="wrap">
      <div className="section-head">
        <span className="section-num">08</span>
        <h2 className="section-title" id="crowd-title">
          Six signs you'll <em>love it here</em>.
        </h2>
      </div>

      <p className="crowd-lead">
        Most of our learners are marketers, founders, strategists and
        entrepreneurs. <strong>What really unites them is character.</strong>
      </p>

      <div className="crowd-grid">
        <article className="trait-card">
          <span className="trait-num">01</span>
          <h3>Allergic to corporate waffle.</h3>
          <p>
            Buzzword bingo gives you a small inward twitch. You'd rather hear
            what actually happened.
          </p>
        </article>

        <article className="trait-card">
          <span className="trait-num">02</span>
          <h3>You'd rather understand than be told.</h3>
          <p>
            "Because that's how it's done" doesn't quite cut it. You want to
            know why, and you usually find out.
          </p>
        </article>

        <article className="trait-card">
          <span className="trait-num">03</span>
          <h3>Smart enough to know what you don't know.</h3>
          <p>
            The opposite of Dunning-Kruger. You'd rather admit ignorance and fix
            it than fake the confidence.
          </p>
        </article>

        <article className="trait-card">
          <span className="trait-num">04</span>
          <h3>Ideas matter more than job titles.</h3>
          <p>
            The best idea wins, regardless of who said it. You've noticed this
            is depressingly rare in most rooms.
          </p>
        </article>

        <article className="trait-card">
          <span className="trait-num">05</span>
          <h3>Suspicious of easy answers.</h3>
          <p>
            You suspect there's a more interesting layer underneath. You usually
            go looking, and you usually find it.
          </p>
        </article>

        <article className="trait-card">
          <span className="trait-num">06</span>
          <h3>Interested before you're impressed.</h3>
          <p>
            "Tell me more" is your preferred response to clever people. It's
            also why clever people tend to like you back.
          </p>
        </article>
      </div>

      <p className="crowd-footer">
        Recognise yourself in three of those? <em>Welcome.</em>
      </p>
    </div>
  </section>
);

export default Crowd;
